import React, { useState } from "react";
import "./PodcastListCard.css";

const EqualizerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 2C7.58 2 4 5.58 4 10C4 12.92 5.57 15.48 8 16.87M12 6C9.79 6 8 7.79 8 10C8 11.46 8.79 12.73 10 13.43M12 2C16.42 2 20 5.58 20 10C20 12.92 18.43 15.48 16 16.87M12 6C14.21 6 16 7.79 16 10C16 11.46 15.21 12.73 14 13.43M12 12V21"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="10" r="2" fill="white" />
  </svg>
);

const PodcastListCard = ({
  podcasts = [],
  isLoading = false,
  onOpen,
  onBookmark,
  onLike,
  onView,
}) => {
  const [expandedCards, setExpandedCards] = useState([]);
  const toggleDescription = (id) =>
    setExpandedCards((current) =>
      current.includes(id)
        ? current.filter((cardId) => cardId !== id)
        : [...current, id],
    );

  if (isLoading)
    return (
      <div className="trackCardsGrid" aria-label="Loading podcasts">
        {Array.from({ length: 4 }).map((_, index) => (
          <div className="trackCard podcast-cardShimmer" key={index} />
        ))}
      </div>
    );

  return (
    <div className="trackCardsWrapper">
      <div className="trackCardsGrid">
        {podcasts.map((item) => {
          const expanded = expandedCards.includes(item.id);
          const locked = item.freePaid === "P" && item.paymentStatus !== 1;
          const color = item.serialNo % 2 ? "purple" : "orange";
          return (
            <article
              className="trackCard"
              key={item.id}
              role="button"
              tabIndex={0}
              onClick={() => onOpen?.(item)}
              onKeyDown={(event) => {
                if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) {
                  event.preventDefault();
                  onOpen?.(item);
                }
              }}
            >
              <div className="trackCardTop w-100">
                <div className="d-flex justify-content-between gap-2 w-100">
                  <div className={`trackIcon ${color}`}>
                    <EqualizerIcon />
                  </div>
                  <div className="trackContent">
                    <div className="trackHeadingRow">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3
                          className={`trackName ${color}`}
                        >{`Track ${item.serialNo}`}</h3>
                        <button
                          type="button"
                          className="bookmarkButton"
                          aria-label={
                            item.isBookmarked
                              ? "Bookmarked podcast"
                              : "Bookmark podcast"
                          }
                          onClick={(event) => {
                            event.stopPropagation();
                            onBookmark?.(item);
                          }}
                        >
                          <i
                            className={`bi ${item.isBookmarked ? "bi-bookmark-fill" : "bi-bookmark"}`}
                          />
                        </button>
                      </div>
                      <div className="trackBadges">
                        {item.isRead ? (
                          <span className="trackBadge">Read</span>
                        ) : null}
                        {locked ? (
                          <span className="unlockBadge">
                            <span className="coinIcon">$</span>Unlock required
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h4 className="trackTitle">{item.title}</h4>
              {item.description ? (
                <div
                  className={`descriptionWrapper ${expanded ? "expandedDescription" : ""}`}
                >
                  <div className="trackDescription">{item.description}</div>
                  <button
                    type="button"
                    className="seeMore"
                    onClick={(event) => {
                      event.stopPropagation();
                      toggleDescription(item.id);
                    }}
                  >
                    {expanded ? "Show less" : "Show more"}
                  </button>
                </div>
              ) : null}
              {item.viewLabel ? (
                <div className="trackTime">
                  <i className="bi bi-clock" />
                  <span>{item.viewLabel}</span>
                </div>
              ) : null}
              <div className="trackCardFooter">
                  <button
                  type="button"
                  className="footerItem likes border-0 bg-transparent"
                  onClick={(event) => {
                    event.stopPropagation();
                    onLike?.(item);
                  }}
                >
                  <i
                    className={`bi ${item.isLiked ? "bi-heart-fill" : "bi-heart"}`}
                  />
                  <span>{`${item.likeCount} Like`}</span>
                </button>
                <button
                  type="button"
                  className="footerItem views border-0 bg-transparent"
                  onClick={(event) => {
                    event.stopPropagation();
                    onView?.(item);
                  }}
                >
                  <i className="bi bi-eye" />
                  <span>{`${item.viewCount} View`}</span>
                </button>
                <div className="footerItem notes">
                  <i className="bi bi-journal-text" />
                  <span>{`${item.notesCount} Notes`}</span>
                </div>
              
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default PodcastListCard;
